import slice from './slice';

const { reducer } = slice;

export * from './actions';
export * from './selectors';
export * from './api';
export { reducer as DronePageReducer };

